import IVideoCaptureService from "../../domain/services/IVideoCapture.service";

export class VideoCaptureUseCase {

  constructor(private videoCaptureSrv: IVideoCaptureService) {}

  public async postVideoRecording(processId: string) {
    try {
      const response = await this.videoCaptureSrv.videoRecording(processId)
      if (response.status != 200)
        return { data: "", error: `Ocurrio un error, status: ${response.status}` };

      return { data: response.data, error: null };
    } catch (error) {
      console.error("Error al obtener url video recording");
      return { data: "", error: `Ocurrio un error ${error}` };
    }
  }

  public async postVideoRecordingRedirect(processId: string, urlRedirect: string) {
    try {
      const response = await this.videoCaptureSrv.videoRecordingRedirect(processId, urlRedirect)
      if (response.status != 200)
        return { data: "", error: `Ocurrio un error, status: ${response.status}` };

      return { data: response.data, error: null };
    } catch (error) {
      console.error("Error al obtener url video recording");
      return { data: "", error: `Ocurrio un error ${error}` };
    }
  }

  public async getVideoRecordingWorkflows(processId: string, uuidVideoCapture: string) {
    try {
      const response = await this.videoCaptureSrv.videoRecordingWorkflows(processId, uuidVideoCapture);
      if (response.status != 200)
        return { data: "", error: `Ocurrio un error, status: ${response.status}` };

      return { data: response.data, error: null };
    } catch (error) {
      console.error("Error al obtener url video recording");
      return { data: "", error: `Ocurrio un error ${error}` };
    }
  }

}
